import { render, staticRenderFns } from "./system-content-transfer.vue?vue&type=template&id=6931ec34&"
import script from "./system-content-transfer.vue?vue&type=script&lang=ts&"
export * from "./system-content-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./system-content-transfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports